import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import { allBahasaKey } from "../../queries/Bahasa/useFetchAllBahasa";
import getQueryClient from "../../queryClient";

export async function removeBahasa(BAHASA_ID: number) {
  const res = await ApiClient.delete(
    `/RemoveBahasa?BAHASA_ID=${BAHASA_ID}`
  );
  return res.data[0];
}

export const useRemoveBahasa = mutationWrapper(removeBahasa, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allBahasaKey);
  },
});
